import React, { useEffect, useState } from 'react';
import { Content, FilterSpacer, Shadow } from './style';
import { Button, Input, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { UpcomingMeetingsFilter } from '../UpcomingMeetingsFilter';
import { useUpcomingMeetings } from '../../../meetings/upcoming-meetings/upcoming-meetings.hook';
import { useDebouncedCallback } from 'use-debounce';
import { FiltersPopover } from '../../../saved-filters/components/FiltersPopover';
import { UPCOMING_MEETINGS_PAGE_KEY } from '../../../meetings/upcoming-meetings/upcoming-meetings.store';
import { MeetingParticipantsSelector } from '../../../insights/portfolio-insights/components/MeetingParticipantsSelector';

const { Search } = Input;

const UpcomingMeetingsFilterBar: React.FC = () => {
  const {
    searchTerm,
    isFetching,
    resetFilters,
    changeSearchTerm,
    saveFiltersView,
    setCurrentFilterView,
    setParticipants,
  } = useUpcomingMeetings();
  const [inputSearchTerm, setInputSearchTerm] = useState('');

  const searchDebounce = useDebouncedCallback(value => {
    changeSearchTerm(value);
  }, 400);

  useEffect(() => {
    setInputSearchTerm(searchTerm);
  }, [searchTerm]);

  const handleChangeInputText = (text: string) => {
    setInputSearchTerm(text);
    searchDebounce(text);
  };

  return (
    <Content>
      <FilterSpacer>
        <Shadow>
          <Search
            placeholder="Search by title, account, or participants"
            style={{ width: 350 }}
            value={inputSearchTerm}
            onChange={ev => handleChangeInputText(ev.target.value)}
          />

          <MeetingParticipantsSelector value={[]} onChange={setParticipants} />

          <UpcomingMeetingsFilter />
        </Shadow>
        <Space size={'large'}>
          <Button disabled={isFetching} onClick={resetFilters} icon={<ReloadOutlined />}>
            Reset Filters
          </Button>

          <FiltersPopover
            pageKey={UPCOMING_MEETINGS_PAGE_KEY}
            onSave={saveFiltersView}
            onSetView={setCurrentFilterView}
            onViewRemoved={() => setCurrentFilterView(null)}
          />
        </Space>
      </FilterSpacer>
    </Content>
  );
};

export default UpcomingMeetingsFilterBar;
